function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12z",
  fill: "#14A96D"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.614 11.21a1 1 0 0 1 .175 1.404l-7 9a1 1 0 0 1-1.496.093l-3-3a1 1 0 1 1 1.414-1.414l2.2 2.199 6.304-8.106a1 1 0 0 1 1.403-.175z",
  fill: "#fff"
});

var SvgCheckCircle = function SvgCheckCircle(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "8ee59f88d48dcc8e8befada492a191dd.svg";
export { SvgCheckCircle as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/check-circle.svg
// module id = null
// module chunks = 